import React, { useState, useMemo, useRef } from 'react'
import { Input, Select, TimePicker, Switch, Button, Tabs, Tooltip, Popconfirm, message } from 'antd'
import moment from 'moment'
import ListCondition from "./ListCondition"
import { CloseOutlined, DoubleRightOutlined, QuestionCircleOutlined, MenuOutlined, DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

function FormRule(props) {
    const {
        priority,
        format,
        validate,
        schedule,
        onChangeTime,
        location,
        onChangeSelect,
        onlyStore,
        onChangeOnlyStore,
        onlyPackage,
        onChangeOnlyPackage,
        status,
        onChangeActive,
        products,
        allSku,
        stores,
        onChangeTagMode,
        tags,
        isFit,
        onChangeIsFit,
        splitByPack,
        onChangeSplitByPack,
        isMultiVariants,
        onChangeMultiVariants,
        isMultiFrames,
        onChangeMultiFrames,
        variants,
        setVariants,
        onChangeVariant,
        onChangeInput,
        partner,
        allPartners,
        removeRecord,
        addCondition,
        handleChangeRecord,
        errors,
        fitCondition,
        addFitCondition,
        removeFitCondition,
        onChangeFitCondition,
        handleDragEnd,
        onChangeMultiBrand,
        isMultiBrands,
        isMultiSizes,
        onChangeMultiSize,
        onAddSizeFrames,
        sizeFrames,
        sizeOfRawMaterials,
        onAddSizeRawMaterials,
    } = { ...props }

    const optionPartner = allPartners.filter(i => i)

    const [activeKey, setActiveKey] = useState('1')
    const [editingKey, setEditingKey] = useState(null)
    const [editingValue, setEditingValue] = useState("")
    const [searchValue, setSearchValue] = useState("")

    const selectRef = useRef(null)
    const timeoutRef = useRef(null)

    const currentVariant = useMemo(() => variants.find(variant => variant.key === activeKey) || {}, [activeKey, variants])
    const { sizes = [], conditions = [], min_variant_quantity = null, is_multi_sizes = false } = Object.assign({}, currentVariant)

    const {
        frames = [],
        coverages = [],
    } = Object.assign({}, fitCondition)

    const listFramesFit = useMemo(() => frames.map(f => !!f.label && f.label), [frames])

    const handleAddTab = () => {
        const newKey = (variants.length + 1).toString()
        const newTab = {
            key: newKey,
            name: "",
            sizes: [],
            min_variant_quantity: null,
            conditions: [],
        }

        setVariants((prev) => [...prev, newTab])
        setEditingKey(newKey)
        setEditingValue("")
    }

    const handleRemoveTab = (key) => {
        const newVariants = variants.filter((tab) => tab.key !== key) || []
        setVariants(newVariants)
        if (key === activeKey && !!newVariants.length) setActiveKey(newVariants[0].key)
    }

    const handleDoubleClick = (key, title) => {
        setEditingKey(key)
        setEditingValue(title)
    }

    const handleChange = (e) => {
        setEditingValue(e.target.value)
    }

    const handleBlur = () => {
        if (!!editingValue && editingValue.trim().length > 50) return message.error('Tên variant tối đa 50 kí tự.')
        setVariants((prev) =>
            prev.map((tab) =>
                tab.key === editingKey ? { ...tab, name: editingValue ? editingValue.trim() : 'New' } : tab
            )
        )
        setEditingKey(null)
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            if (editingValue.trim() !== "") {
                handleBlur()
            }
        }
    }

    const handleKeyDownVariant = (event) => {
        if (event.key === "Enter" && event.target.value.trim() !== "") {
            const newValue = [...sizes, event.target.value.trim()]
            onChangeVariant(activeKey, "sizes", newValue)
            event.preventDefault()
            selectRef.current.blur()
            setTimeout(() => selectRef.current.focus(), 300)
        }
    }

    const _handleChangeMultiVariants = (value) => {
        onChangeMultiVariants(value)
        if (!currentVariant.name) setEditingKey('1')
        setEditingValue('')
        setVariants([currentVariant])
    }

    const callback = (key) => {
        setActiveKey(key)
    }

    const handleSearchFitCondition = (value) => {
        setSearchValue(value)

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
        }

        timeoutRef.current = setTimeout(() => {
            const isValidFormat = /^\d+x\d+$/.test(value)
            if (!isValidFormat) return

            if (!sizeOfRawMaterials.some(opt => opt.label === value)) {
                const [w, h] = value.split("x")
                const newValue = { label: `${w}x${h}`, w, h }
                onAddSizeRawMaterials(newValue)
            }
        }, 500)
    }

    const handleKeyDownFitCondition = (e, idCondition, field, fieldParent) => {
        if (e.key === "Enter") {
            onChangeFitCondition(idCondition, field, searchValue, fieldParent)
        }
    }

    return (
        <div className="FormRule row" style={{ minHeight: '80vh' }}>
            <div className="col-4" style={{ borderRight: '1px dashed #bba8a8' }}>
                <div className="row mb-3">
                    <div className="Priority col-6 pl-0">
                        <label>Priority <span className="text-danger">*</span></label>
                        <Input
                            type="number"
                            className={(!!validate.priority && validate.priority.length > 0) ? 'Error' : ''}
                            value={priority || ''}
                            allowClear
                            onChange={(e) => onChangeInput('priority', e)}
                            placeholder="Nhập priority"
                        />
                        {
                            !!validate.priority && validate.priority.length > 0 &&
                            <small className="Validate">{validate.priority}</small>
                        }
                    </div>
                    <div className="Partner col-6 pl-0">
                        <label>Partner <span className="text-danger">*</span></label>
                        <Select
                            className={`${(!!validate.partner && validate.partner.length > 0) ? 'Error' : ''} w-100`}
                            name="partner"
                            placeholder="Chọn partner"
                            value={partner || []}
                            allowClear
                            onChange={(e) => onChangeSelect('partner', e)}
                        >
                            {!!optionPartner.length && optionPartner.map((i, index) => (
                                <Select.Option key={i._id} value={i._id}>{i.name}</Select.Option>
                            ))}
                        </Select>
                        {
                            !!validate.partner && validate.partner.length > 0 &&
                            <small className="Validate">{validate.partner}</small>
                        }
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="schedule col-6 pl-0">
                        <label className="d-block">Schedule <span className="text-danger">*</span></label>
                        <TimePicker
                            format="HH:mm"
                            className={`${(!!validate.start && validate.start.length > 0) ? 'Error' : ''}`}
                            style={{ width: '100%' }}
                            value={!!schedule.start ? moment(schedule.start, format) : undefined}
                            onChange={(e, value) => onChangeTime('start', value)}
                            placeholder='Start time'
                        />
                    </div>
                    <div className="schedule col-6 pl-0">
                        <label className="d-block" >&nbsp;</label>
                        <TimePicker
                            format="HH:mm"
                            className={`${(!!validate.end && validate.end.length > 0) ? 'Error' : ''}`}
                            style={{ width: '100%' }}
                            value={!!schedule.end ? moment(schedule.end, format) : undefined}
                            onChange={(e, value) => onChangeTime('end', value)}
                            placeholder='End time'
                        />
                    </div>
                    {
                        !!validate.end && validate.end.length > 0 &&
                        <label className="Validate mb-0 w-100">{validate.end}</label>
                    }
                </div>

                <div className="row mb-3">
                    <div className="Location col-12 pl-0">
                        <label>Location</label>
                        <Select
                            className={`w-100`}
                            name="location"
                            placeholder="Chọn địa điểm sản xuất"
                            value={location || []}
                            allowClear
                            onChange={(e) => onChangeSelect('location', e)}
                        >
                            <Select.Option value="MC">MC Lab</Select.Option>
                        </Select>
                    </div>
                </div>

                <div className="row mb-3 d-flex justify-content-between pr-3">
                    <div className="onlyStore d-flex align-items-center">
                        <label className="d-block mb-0">Only store</label>
                        <Switch checked={onlyStore} onChange={onChangeOnlyStore} className="ml-2" />
                    </div>
                    <div className="onlyPackage d-flex align-items-center">
                        <label className="d-block mb-0">Only package</label>
                        <Switch checked={onlyPackage} onChange={onChangeOnlyPackage} className="ml-2" />
                    </div>
                    <div className="multiBrand d-flex align-items-center">
                        <Tooltip
                            title={isMultiBrands ? 'Lô tạo thành có thể chứa nhiều brands' : 'Lô tạo thành chỉ chứa 1 brand'}
                            className='d-flex align-items-center'
                        >
                            <label className="d-block mb-0">Brands</label>
                            <Switch checked={isMultiBrands} onChange={onChangeMultiBrand} className="ml-2" />
                        </Tooltip>
                    </div>
                    <div className="onlyPackage d-flex align-items-center">
                        <label className="d-block mb-0">Active</label>
                        <Switch checked={status} onChange={onChangeActive} className="ml-2" />
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="Product col-12 pl-0">
                        <label className="d-block">Products</label>
                        <div className="d-flex">
                            <Select defaultValue={'exclude'} value={products.mode || 'exclude'}
                                style={{ width: '70px' }}
                                onChange={(e) => onChangeSelect('product', e)}>
                                <Select.Option value={'include'}>Gồm</Select.Option>
                                <Select.Option value={'exclude'}>Trừ</Select.Option>
                            </Select>
                            <Select
                                className={`${(!!validate.sku && validate.sku.length > 0) ? 'Error' : ''} w-100 ml-2`}
                                mode="tags"
                                style={{ width: '100%' }}
                                showArrow={true}
                                placeholder="Chọn loại sản phẩm"
                                tokenSeparators={[',', ' ']}
                                value={products.sku}
                                allowClear
                                onChange={(e) => onChangeSelect('sku', e)}
                            >
                                {!!allSku.length && allSku.map((i, index) => (
                                    <Select.Option key={i._id} value={i.sku}>{i.sku}</Select.Option>
                                ))}
                            </Select>
                        </div>
                        {
                            !!validate.sku && validate.sku.length > 0 && <label className="Validate mb-0">{validate.sku}</label>
                        }
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="Stores col-12 pl-0">
                        <label className="d-block">Stores</label>
                        <div className="d-flex">
                            <Select
                                defaultValue={'exclude'}
                                style={{ width: '70px' }}
                                value={stores.mode || 'exclude'}
                                onChange={(e) => onChangeSelect('stores', e)}
                            >
                                <Select.Option value={'include'}>Gồm</Select.Option>
                                <Select.Option value={'exclude'}>Trừ</Select.Option>
                            </Select>
                            <Select
                                className={`${(!!validate.stores && validate.stores.length > 0) ? 'Error' : ''} w-100 ml-2`}
                                value={stores.list || []}
                                placeholder="Nhập stores"
                                mode="tags"
                                onChange={(value) => onChangeTagMode('stores', value)}
                                tokenSeparators={[',', ' ']}
                                allowClear
                                open={false}
                            />
                        </div>
                        {
                            !!validate.stores && validate.stores.length > 0 &&
                            <label className="Validate mb-0">{validate.stores}</label>
                        }
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="required_tags col-12 pl-0">
                        <label className="d-block">Tags</label>
                        <div className="d-flex">
                            <Select defaultValue={'exclude'} value={tags.mode || 'exclude'}
                                style={{ width: '70px' }}
                                onChange={(e) => onChangeSelect('tags', e)}>
                                <Select.Option value={'include'}>Gồm</Select.Option>
                                <Select.Option value={'exclude'}>Trừ</Select.Option>
                            </Select>
                            <Select
                                className={`${(!!validate.tags && validate.tags.length > 0) ? 'Error' : ''} w-100 ml-2`}
                                value={tags.tags || []}
                                placeholder="Nhập tags"
                                tokenSeparators={[',', ' ']}
                                mode="tags"
                                onChange={(value) => onChangeTagMode('tags', value)}
                                allowClear
                                open={false}
                            />
                        </div>
                        {
                            !!validate.tags && validate.tags.length > 0 &&
                            <label className="Validate mb-0">{validate.tags}</label>
                        }
                    </div>
                </div>
            </div>

            <div className="col-8">
                <div className="row mb-4">
                    <div className="isFit d-flex" style={{ marginRight: '50px' }}>
                        <Switch
                            checked={isFit}
                            checkedChildren="Diện tích"
                            unCheckedChildren="Số lượng"
                            onChange={onChangeIsFit}
                            className={`ml-3 custom-switch ${isFit ? 'area-switch' : 'quantity-switch'}`}
                        />
                    </div>
                    {
                        isFit ?
                            <div className="d-flex">
                                <div className="splitByPack d-flex" style={{ marginRight: '50px' }}>
                                    <label className="d-block mb-0">Tách theo pack</label>
                                    <Switch checked={splitByPack} onChange={onChangeSplitByPack} className="ml-3" />
                                </div>
                            </div> :
                            <>
                                <div className="d-flex">
                                    <div className="isMultiVariants d-flex align-items-center" style={{ marginRight: '50px' }}>
                                        <label className="d-block mb-0">Variant</label>
                                        <Switch checked={isMultiVariants} onChange={_handleChangeMultiVariants} className="ml-3" />
                                    </div>
                                </div>
                                {
                                    isMultiVariants ?
                                        <div className="d-flex align-items-center">
                                            <div className="isMultiFrames d-flex" style={{ marginRight: '50px' }}>
                                                <label className="d-block mb-0">Lưới</label>
                                                <Switch checked={isMultiFrames} onChange={onChangeMultiFrames} className="ml-3" />
                                            </div>
                                        </div> :
                                        <div className="d-flex">
                                            <div className="isMultiFrames d-flex" style={{ marginRight: '50px' }}>
                                                <Tooltip
                                                    title={isMultiSizes ? 'Lô tạo thành chứa nhiều size' : 'Lô tạo thành chỉ chứa 1 size'}
                                                    className='d-flex align-items-center'
                                                >
                                                    <label className="d-block mb-0">Sizes</label>
                                                    <Switch checked={isMultiSizes} onChange={onChangeMultiSize} className="ml-2" />
                                                </Tooltip>
                                            </div>
                                        </div>
                                }
                            </>
                    }
                </div>

                {
                    !isFit && isMultiVariants &&
                    <React.Fragment>
                        <div className="row col-12 flex-column">
                            <label className="d-block" style={{ fontSize: '18px' }}>Variant</label>
                            <div className="list-variants">
                                <Tabs onChange={callback} type="card">
                                    {
                                        variants.map((variant) => {
                                            return (
                                                <Tabs.TabPane
                                                    tab={
                                                        editingKey === variant.key ? (
                                                            <Input
                                                                size="small"
                                                                style={{ width: '100px' }}
                                                                value={editingValue}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                onKeyDown={handleKeyDown}
                                                                autoFocus
                                                            />
                                                        ) : (
                                                            <span
                                                                className='px-0 d-flex align-items-center'
                                                                style={{ fontWeight: 600 }}
                                                                onDoubleClick={() => handleDoubleClick(variant.key, variant.name)}
                                                            >
                                                                {variant.name || 'New'}{variants.length > 1 && <CloseOutlined className='ml-2' onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    handleRemoveTab(variant.key)
                                                                }} />}
                                                            </span>
                                                        )
                                                    }
                                                    key={variant.key}
                                                />
                                            )
                                        })
                                    }
                                    <Tabs.TabPane
                                        tab={
                                            <Button
                                                type="dashed"
                                                style={{ border: "none", background: "transparent" }}
                                                className='px-0'
                                                onClick={handleAddTab}
                                            >
                                                + Thêm variant
                                            </Button>
                                        }
                                        key="add-tab"
                                        disabled
                                    />
                                </Tabs>
                            </div>
                        </div>
                        {
                            !!currentVariant.name &&
                            <div className="row mb-3 col-12 d-flex align-items-center">
                                <div className="col-1 multiBrand d-flex align-items-center px-0">
                                    <Tooltip
                                        title={is_multi_sizes ? 'Lô tạo thành chứa nhiều size' : 'Lô tạo thành chỉ chứa 1 size'}
                                        className='d-flex align-items-center'
                                    >
                                        <label className="d-block mb-0">Sizes</label>
                                        <Switch checked={is_multi_sizes} onChange={e => onChangeVariant(activeKey, 'is_multi_sizes', !is_multi_sizes)} className="ml-2" />
                                    </Tooltip>
                                </div>
                                <div className="list-variant col-11 d-flex align-items-center justify-content-between px-0">
                                    <label className="d-flex align-items-center mb-0 pl-3" style={{ color: '#d3d5d7', fontWeight: 'normal' }}>
                                        Danh sách variant<DoubleRightOutlined className='ml-3' />
                                    </label>
                                    <Select
                                        ref={selectRef}
                                        style={{ width: '80%' }}
                                        className='custom-select-variant'
                                        value={sizes || []}
                                        placeholder="Nhập variant"
                                        tokenSeparators={[',']}
                                        mode="tags"
                                        onChange={(value) => onChangeVariant(activeKey, 'sizes', value)}
                                        onInputKeyDown={handleKeyDownVariant}
                                        allowClear
                                        open={false}
                                    />
                                </div>
                            </div>
                        }
                    </React.Fragment>
                }

                <div className="row">
                    <div className="required_tags col-12">
                        {
                            !isFit ?
                                (!!currentVariant.name || currentVariant.name === "__ALL_SIZE__") &&
                                <React.Fragment>
                                    <div className="d-flex align-items-center mb-3">
                                        <label className="d-block mr-5" style={{ fontSize: '18px' }}>Chi tiết</label>
                                        {
                                            isMultiFrames &&
                                            <div className='d-flex align-items-center'>
                                                <label className="d-block mr-3" style={{ fontSize: '16px' }}>Số item tối thiểu</label>
                                                <Input
                                                    type="number"
                                                    min={1}
                                                    style={{ width: '100px' }}
                                                    value={min_variant_quantity}
                                                    onChange={e => {
                                                        const value = e.target.value
                                                        if (/^\d+$/.test(value) && +value > 0) {
                                                            onChangeVariant(activeKey, 'min_variant_quantity', +value)
                                                        }
                                                    }}
                                                />
                                                <Tooltip
                                                    title='Lượng item tối thiểu để có thể tạo lô'
                                                ><QuestionCircleOutlined style={{ fontSize: '18px' }} className='ml-3 cursor-pointer' /></Tooltip>
                                            </div>
                                        }
                                    </div>
                                    <ListCondition
                                        conditions={conditions}
                                        partners={allPartners}
                                        removeRecord={removeRecord}
                                        addCondition={addCondition}
                                        onChangeRecord={handleChangeRecord}
                                        isFit={isFit}
                                        activeKey={activeKey}
                                        isMultiFrames={isMultiFrames}
                                        handleDragEnd={handleDragEnd}
                                        onAddSizeFrames={onAddSizeFrames}
                                        sizeFrames={sizeFrames}
                                    />
                                </React.Fragment>
                                :
                                <div className="row fit-condition d-flex">
                                    <div className="col-4" style={{ borderRight: '1px dashed #bba8a8', minHeight: '450px' }}>
                                        <table className="frames-table">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>Khổ nguyên vật liệu <span className="text-danger">*</span></th>
                                                    <th>Enable</th>
                                                </tr>
                                            </thead>
                                            <DragDropContext onDragEnd={(result) => handleDragEnd(result, "frames")}>
                                                <Droppable droppableId="frames-list" direction="vertical">
                                                    {(provided) => (
                                                        <tbody ref={provided.innerRef} {...provided.droppableProps}>
                                                            {frames.map((fr, index) => (
                                                                <Draggable key={fr._idx} draggableId={String(fr._idx)} index={index}>
                                                                    {(provided, snapshot) => (
                                                                        <tr
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            style={{
                                                                                ...provided.draggableProps.style
                                                                            }}
                                                                        >
                                                                            <td {...provided.dragHandleProps}>
                                                                                <MenuOutlined style={{ cursor: 'grab' }} />
                                                                            </td>
                                                                            <td>
                                                                                <Select
                                                                                    placeholder="Chọn khổ"
                                                                                    value={fr.label ? fr.label : []}
                                                                                    allowClear
                                                                                    onChange={value => onChangeFitCondition(fr._idx, 'type', value, "frames")}
                                                                                    onSearch={handleSearchFitCondition}
                                                                                    onInputKeyDown={e => handleKeyDownFitCondition(e, fr._idx, 'type', "frames")}
                                                                                    style={{ width: '150px' }}
                                                                                    showSearch
                                                                                >
                                                                                    {
                                                                                        sizeOfRawMaterials.map((raw_material, i) => (
                                                                                            <Select.Option disabled={listFramesFit.includes(raw_material.label)} key={i} value={raw_material.label}>{raw_material.label}</Select.Option>
                                                                                        ))
                                                                                    }
                                                                                </Select>
                                                                            </td>
                                                                            <td>
                                                                                <div className="d-flex align-items-center">
                                                                                    <Input
                                                                                        type="checkbox"
                                                                                        className='custom-enable mr-2'
                                                                                        checked={fr.is_enable}
                                                                                        onChange={() => onChangeFitCondition(fr._idx, 'is_enable', !fr.is_enable, "frames")}
                                                                                    />
                                                                                    <Popconfirm placement='topRight' title="Xóa thông tin tạo lô cho đối tác này?" onConfirm={() => removeFitCondition("frames", fr._idx)}>
                                                                                        <DeleteOutlined
                                                                                            style={{ pointerEvents: frames.length <= 1 ? 'none' : 'unset', fontSize: '20px', cursor: 'pointer' }}
                                                                                        />
                                                                                    </Popconfirm>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </Draggable>
                                                            ))}
                                                            <tr>
                                                                <td></td>
                                                                <td></td>
                                                                <td>
                                                                    <div className="d-flex align-items-center">
                                                                        <PlusCircleOutlined onClick={() => addFitCondition("frames")} style={{ marginLeft: '30px' }} />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            {provided.placeholder}
                                                        </tbody>
                                                    )}
                                                </Droppable>
                                            </DragDropContext>
                                        </table>
                                    </div>

                                    <div className="col-8">
                                        <table className="coverages-table">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>Tỉ lệ phủ tối thiểu <span className="text-danger">*</span></th>
                                                    <th>Partner <span className="text-danger">*</span></th>
                                                </tr>
                                            </thead>
                                            <DragDropContext onDragEnd={(result) => handleDragEnd(result, "coverages")}>
                                                <Droppable droppableId="coverages-list" direction="vertical">
                                                    {(provided) => (
                                                        <tbody ref={provided.innerRef} {...provided.droppableProps}>
                                                            {coverages.map((cr, index) => (
                                                                <Draggable key={cr._idx} draggableId={String(cr._idx)} index={index}>
                                                                    {(provided, snapshot) => (
                                                                        <tr
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            style={{
                                                                                ...provided.draggableProps.style
                                                                            }}
                                                                        >
                                                                            <td {...provided.dragHandleProps}>
                                                                                <MenuOutlined style={{ cursor: 'grab' }} />
                                                                            </td>
                                                                            <td>
                                                                                <Input
                                                                                    type="number"
                                                                                    value={cr.rate}
                                                                                    style={{ width: '200px' }}
                                                                                    placeholder='Tỉ lệ'
                                                                                    onChange={e => onChangeFitCondition(cr._idx, 'rate', e.target.value, "coverages")}
                                                                                />
                                                                            </td>
                                                                            <td>
                                                                                <Select
                                                                                    placeholder="Chọn partner"
                                                                                    value={cr.partner || []}
                                                                                    allowClear
                                                                                    onChange={value => onChangeFitCondition(cr._idx, 'partner', value, "coverages")}
                                                                                    style={{ width: '200px' }}
                                                                                >
                                                                                    {!!optionPartner.length && optionPartner.map((i, index) => (
                                                                                        <Select.Option key={i._id} value={i._id}>{i.name}</Select.Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </td>
                                                                            <td>
                                                                                <div className="d-flex align-items-center">
                                                                                    <Input
                                                                                        type="checkbox"
                                                                                        className='custom-enable mr-2'
                                                                                        checked={cr.is_enable}
                                                                                        onChange={() => onChangeFitCondition(cr._idx, 'is_enable', !cr.is_enable, "coverages")}
                                                                                    />
                                                                                    <Popconfirm placement='topRight' title={`Xóa thông tin tạo lô cho đối tác này?`} onConfirm={() => removeFitCondition("coverages", cr._idx)}>
                                                                                        <DeleteOutlined style={{ pointerEvents: coverages.length <= 1 ? 'none' : 'unset', fontSize: '20px', cursor: 'pointer' }} />
                                                                                    </Popconfirm>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </Draggable>
                                                            ))}
                                                            <tr>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td>
                                                                    <div className="d-flex align-items-center">
                                                                        <PlusCircleOutlined onClick={() => addFitCondition("coverages")} style={{ marginLeft: '30px' }} />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            {provided.placeholder}
                                                        </tbody>
                                                    )}
                                                </Droppable>
                                            </DragDropContext>
                                        </table>
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </div>

            {
                errors && <div className="ValidateError">
                    {
                        errors.split("\n").map((e, index) => <p key={index}>{e}</p>)
                    }
                </div>
            }
        </div>
    )
}

export default FormRule